import React from 'react';
import './NotFound.css';
import notFoundImage from '../../assets/logo.png'; // Add an image to your assets folder

const NotFound = () => {
  return (
    <div className="not-found-container">
      <img src={notFoundImage} alt="404 Not Found" className="error-logo" />
      <h1 className="not-found-title">404</h1>
      <p className="not-found-message">We couldn't find the page you were looking for.</p>
      <a href="/" className="not-found-link">Go to Homepage</a>
    </div>
  );
};

export default NotFound;
